exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buttons[data-v-3e37c874] {\n  display: flex;\n  justify-content: right;\n  text-align: right;\n  margin-top: 10px;\n  margin-right: 100px;\n}\n", ""]);

// exports
